<template>
  <div class="king-kong" id="kingKong">
    <div class="king-warp">
      <div class="king-items" v-scroll="scrollFn">
        <div class="king-item" v-for="(item, index) in items" :key="item.id" @click="goPage(item, index)">
          <vanImg class="king-img" :src="item.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt="" />
          <span :style="{'color': `${item.fontColor}`}">{{item.name}}</span>
        </div>
      </div>
    </div>
    <div id="kpw" class="king-process" v-if="items.length > 5"><span id="kp" :style="{left: processLeft}"></span></div>
  </div>
</template>

<script>
import { domBgColorSet } from '../common'

export default {
  name: 'kingkong',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bgInfo: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      kingBgInfo: this.bgInfo,
      processLeft: 0,
      moveLeft: ''
    }
  },
  watch: {
    bgInfo(newVal) {
      console.log('headerTopbar bgInfo==>', newVal)
      this.kingBgInfo = newVal
      this.renderBgInfo()
    }
  },
  mounted() {
    let kpw = document.getElementById('kpw')?.offsetWidth || 0
    let kp = document.getElementById('kp')?.offsetWidth || 0
    this.moveLeft = (kpw - kp) / kpw
    this.renderBgInfo()
  },
  directives: {
    scroll: {
      bind(el, binding) {
        el.addEventListener('scroll', (ev) => {
          let items = document.querySelectorAll('.king-item')
          let itemsWidth = 0;
          items.forEach(item => {
            itemsWidth += item.offsetWidth
          })
          // console.log(ev.target.scrollLeft, ev.target.offsetWidth)
          binding.value(ev.target.scrollLeft / (itemsWidth - ev.target.offsetWidth))
        })
      }
    }
  },
  methods: {
    renderBgInfo() {
      domBgColorSet(this.kingBgInfo, 'kingKong')
    },
    scrollFn(left) {
      this.processLeft = `${(this.moveLeft * left * 100)}%`;
    },
    goPage(item, index) {
      // 埋点
      this.$util.gioTrackWithVariable('MB15595', {
        site_number: index + 1 + '',
        text: item.name || 'null'
      })
      if (item.hyperType === undefined) {
        this.$store.dispatch('bannerTypeFiveClick', { hyperLink: item.linkUrl });
      } else {
        this.$store.dispatch('goPageByType', {
          type: item.hyperType,
          params: item.hyperParam,
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.king-kong{
  position: relative;
  margin: .24rem .32rem;
  padding: .3rem .2rem;
  height: 1.5rem;
  border-radius: .24rem;
  backdrop-filter: blur(.28rem);
  padding-bottom: .32rem;
  overflow: hidden;
  @include synShadow;
}
.king-warp{
  height: 1.3rem;
  overflow: hidden;
}

.king-items{
  height: 1.5rem;
  overflow-x: auto;
  white-space: nowrap;
}

.king-item{
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: .1rem;
  height: 1.34rem;
  &:last-child{
    padding-right: 0;
  }
  .king-img{
    width: .84rem;
    height: .84rem;
    vertical-align: top;
    :deep(img) {
      -webkit-touch-callout: none;
      pointer-events: none;
    }
  }
  span{
    margin-top: .04rem;
    width: 1.2rem;
    display: inline-block;
    vertical-align: top;
    font-size: .24rem;
    line-height: .28rem;
    text-align: center;
    color: #111111;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
  }
}

.king-process{
  position: absolute;
  left: 50%;
  bottom: .15rem;
  margin-left: -.24rem;
  width: .48rem;
  height: .08rem;
  background: #d8d8d8;
  border-radius: .1rem;
  overflow: hidden;
  font-size: 0;
  span{
    position: absolute;
    height: .08rem;
    width: .24rem;
    left: 0;
    top: 0;
    border-radius: .2rem;
    background: #2878FF;
  }
}
</style>
